import React, { useState } from 'react';
interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'bottom' | 'left' | 'right';
}
const Tooltip: React.FC<TooltipProps> = ({
  content,
  children,
  position = 'top'
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const positionClasses = {
    top: 'bottom-full mb-2',
    bottom: 'top-full mt-2',
    left: 'right-full mr-2',
    right: 'left-full ml-2'
  };
  return <div className="relative inline-block" data-id="element-68">
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} onFocus={() => setIsVisible(true)} onBlur={() => setIsVisible(false)} data-id="element-69">
        {children}
      </div>
      {isVisible && <div className={`absolute z-10 px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-md shadow-sm ${positionClasses[position]}`} role="tooltip" aria-hidden={!isVisible} data-id="element-70">
          {content}
          <div className="tooltip-arrow" data-id="element-71" />
        </div>}
    </div>;
};
export default Tooltip;